import {
  useGame,
  usePlayer,
  usePlayers,
  useRound,
  useStage,
} from "@empirica/core/player/classic/react";
import React from "react";
import { Timer } from "./components/Timer";
import { dollars, getLossFrameBannerInfo } from "./lossFrameMoney";
import { getCounterpartCopy } from "./payoffFrame";

export function Profile() {
  const game = useGame();
  const player = usePlayer();
  const players = usePlayers();
  const round = useRound();
  const stage = useStage();
  const roundName = round ? round.get("name") : "";
  const stageName = stage ? stage.get("name") : "";
  const task = round?.get("task");
  const design = game?.get("design") || {};
  const counterpart = getCounterpartCopy(design);
  const moneyBanner = getLossFrameBannerInfo({
    design,
    task,
    player,
    players,
    game,
  });
  const showStageName =
    stageName && (!roundName || !stageName.startsWith(roundName));

  const baseCardClass =
    "px-3 py-2 text-gray-500 rounded-md grid grid-cols-3 items-center border-.5";
  const normalCardClass = `min-w-lg md:min-w-2xl mt-2 mx-auto ${baseCardClass}`;

  const profileContent = (
    <>
      <div className="leading-tight ml-1">
        {/* BANNER FONT SIZE */}
        <div className="text-4xl text-gray-600 font-semibold">{roundName}</div>
        {showStageName ? (
          <div className="text-2xl text-empirica-500 font-medium">{stageName}</div>
        ) : null}
      </div>

      <Timer />

      <div className="justify-self-end text-right leading-tight">
        {moneyBanner ? (
          <>
            <div className="text-3xl font-semibold text-gray-700">
              You: {dollars(moneyBanner.you)}
            </div>
            <div className="text-3xl font-semibold text-gray-700">
              {counterpart.capitalizedTerm}: {moneyBanner.hidePartnerMoney ? "--" : dollars(moneyBanner.partner)}
            </div>
          </>
        ) : null}
      </div>
    </>
  );

  return (
    <div className={normalCardClass}>
      {profileContent}
    </div>
  );
}
